import script from "./StudioPipeline.vue?vue&type=script&setup=true&lang=js"
export * from "./StudioPipeline.vue?vue&type=script&setup=true&lang=js"

import "./StudioPipeline.vue?vue&type=style&index=0&id=18dbdf49&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-18dbdf49"]])

export default __exports__